import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
var nameToPath = function nameToPath(name) {
  return name.replace(/]/g, '').split('[');
};

var fixObj = function fixObj(obj, key) {
  if (isNaN(key) && (Array.isArray(obj) || _typeof(obj) !== 'object' || obj === null)) {
    return {};
  }

  if (!isNaN(key) && !Array.isArray(obj)) {
    return [];
  }

  if (isNaN(key)) {
    return _objectSpread({}, obj);
  } // @ts-ignore


  return _toConsumableArray(obj);
};
/**
 * Deeply get a value from an object via its path.
 *
 * @param {object} obj The object to query.
 * @param {string} name The path of the property to get.
 * @param {*} def The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 *
 * @example
 * const name = getIn(state, 'user[name]', 'Anonymous');
 *
 */


var getIn = function getIn(obj, name, def) {
  var path = nameToPath(name);
  var val;

  try {
    val = path.reduce(function (curr, key) {
      return curr[key];
    }, obj);
  } catch (_unused) {}

  return val === undefined ? def : val;
};
/**
 * Deeply set a value from in object via it's path.
 * Does not mutate an original object.
 *
 * @param {object} obj The object to query.
 * @param {string} name The path of the property to set.
 * @param {*} val The value to set.
 * @returns {object} Returns a new object.
 *
 * @example
 * const nextState = setIn(state, 'user[name]', 'John');
 */


var setIn = function setIn(obj, name, val) {
  var path = nameToPath(name);
  var next = fixObj(obj, path[0]);
  var key;
  var curr = next;

  while ((key = path.shift()) && path.length) {
    curr[key] = fixObj(curr[key], path[0]);
    curr = curr[key];
  }

  if (key) {
    curr[key] = val;
  }

  return next;
};

export { getIn, setIn };